export const iconFontAwesomeMedicalHealthHandDots = (
	<i className="fa-solid fa-hand-dots"></i>
);
